// src/itemApi.js
import api from "./api/client";

// Adjust these paths if your backend differs (standard shown)
export const fetchItems = () => api.get("/api/items");
export const fetchTradeItems = () => api.get("/api/items/trade/catalog");
export const fetchItem = (id) => api.get(`/api/items/${id}`);
export const createItem = (payload) => api.post("/api/items", payload);
export const updateItem = (id, payload) => api.put(`/api/items/${id}`, payload);
export const deleteItem = (id) => api.delete(`/api/items/${id}`);
